import { Accordion, Alert, Box, Button, Card, Center, Checkbox, Collapse, Divider, Grid, Group, Loader, NumberInput, Select, Stack, Tabs, Text, TextInput, TransferList, UnstyledButton } from "@mantine/core"
import { useDataProvider } from "../../../data_provider/StandardDataProvider"
import { forwardRef, useEffect, useState } from "react"
import { useGetLighthouseDashboardConfigQuery, useUpdateLighthouseDashboardConfigMutation } from "../../../../redux/slices/LighthouseDashboardConfigSlice"
import { useOutletContext } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleDown, faArrowDown, faCaretDown, faChevronDown, faChevronUp, faMinusCircle, faPlusCircle } from "@fortawesome/free-solid-svg-icons"
import _ from "lodash"



export const Content = () => {
        
    const configQuery = useGetLighthouseDashboardConfigQuery()

    return (
        <Stack style={{overflow: "auto"}}>
            {configQuery.isLoading && <Center style={{height: "100%"}}><Loader variant="bars" color="red" /></Center>}
            {configQuery.isError && !configQuery.isLoading && <Center mt={15}><Alert color="red">{configQuery.error.data.detail || "Sorry an error occurred."}</Alert></Center>}
            {configQuery.data && <ConfigSection initialConfig={configQuery.data} />}
        </Stack>
    )
}

const ConfigSection = ({initialConfig}) => {

    const { assetFrameworkServices } = useOutletContext()

    const [config, setConfig] = useState(initialConfig)
    const [expandedAccordionTagGroupId, setExpandedAccordionTagGroupId] = useState()
    const [eventTemplateTLData, setEventTemplateTLData] = useState(() => {
        const activeEventTemplateIds = config.event_template_ids || []
        const eventTemplatesActive = []
        const eventTemplatesInactive = []
        assetFrameworkServices.getEventTemplates().forEach(e => {
            if (activeEventTemplateIds.includes(e._id)) eventTemplatesActive.push(e)
            else eventTemplatesInactive.push(e)
        })
        return [
            eventTemplatesInactive.map(x => Object({label: x.code, value: String(x._id)})),
            eventTemplatesActive.map(x => Object({label: x.code, value: String(x._id)}))
        ]
    })
    const[updateConfigApi, {isLoading, isError, error, isSuccess}] = useUpdateLighthouseDashboardConfigMutation()

    const updateConfig = (fn) => {
        setConfig((config_) => {
            const newConfig = _.cloneDeep(config_)
            fn(newConfig)
            return newConfig
        })
    }
    const configTagGroups = config.tag_groups || []

    console.log(config)


    return (
        <Stack pb={20}>
            <Stack spacing="xs">
                <Text size="xl" weight={500} color="black">Event Display</Text>
                <Divider style={{width: "150px"}} />

                <Group>
                    <Text size="sm">Display closed events up to</Text>
                    <NumberInput
                        value={config.event_look_back_duration__hrs}
                        onChange={(value) => {
                            updateConfig((config_) => {
                                config_.event_look_back_duration__hrs = value
                            })
                        }}
                        hideControls
                        min={1}
                        max={24}
                        style={{width: "100px"}}
                    />
                    <Text size="sm">hours ago.</Text>
                </Group>

                <Stack spacing={0}>
                    <Text size="lg" weight={600}>Event Templates</Text>
                    <Text size="sm">Select the event templates that will be displayed in the dashboard event list.</Text>
                </Stack>
                <TransferList
                    value={eventTemplateTLData}
                    onChange={(newData) => {
                        const activeEventTemplateIds = newData[1].map(x => Number(x.value))
                        updateConfig((config_) => {
                            config_.event_template_ids = activeEventTemplateIds
                            return config_
                        })
                        setEventTemplateTLData(newData)
                    }}
                    titles={["Inactive", "Active"]}
                    listHeight={150}
                    showTransferAll={false}
                    style={{maxWidth: "900px"}}
                />
            </Stack>

            <Text size="xl" weight={500} color="black">Realtime Data Display</Text>
            <Divider style={{width: "250px"}} />

            <Stack spacing="sm">
                <Stack spacing={0}>
                    <Text size="lg" weight={600}>Project Tag Groups</Text>
                    <Text size="sm">Select the tag groups containing the tags that will be displayed in the real time data panel.</Text>
                </Stack>
            </Stack>

            {configTagGroups.length===0 && <Text weight={500}>No tag groups.</Text>}
            {configTagGroups.length > 0 && 
                <Stack spacing={0}>
                    {configTagGroups.map((tagGroup, i1) => {
                        const Label = (
                            <Group>
                                <Text weight={500} color="black">{assetFrameworkServices.getSites(tagGroup.site_id).name}</Text>
                                <Text color="black">/</Text>
                                <Text color="black">{tagGroup.name}</Text>
                            </Group>
                        )
                        return (
                            <Box>
                                <Group sx={{"&: hover": {backgroundColor: "#F8F9FA", cursor: "pointer"}}} p={15} onClick={() => setExpandedAccordionTagGroupId(tagGroup._id===expandedAccordionTagGroupId ? null : tagGroup._id)}>
                                    <Center>
                                        <Box><FontAwesomeIcon icon={expandedAccordionTagGroupId===Number(tagGroup._id) ? faChevronUp : faChevronDown} /></Box>
                                    </Center>
                                    {Label}
                                </Group>
                                <Box pl={41}>
                                    {expandedAccordionTagGroupId===Number(tagGroup._id) && <TagGroupTagsGrid tagGroup={tagGroup} i1={i1} updateConfig={updateConfig} />}
                                </Box>
                            </Box>
                        )
                    })}
                </Stack>
            }
            <AddTagGroupSection
                updateConfig={updateConfig}
                configTagGroups={configTagGroups}
            />
            <Divider />
            <Stack>
                {isError && <Alert color="red">{error.data.detail || "Sorry an error occurred."}</Alert>}
                {isSuccess && <Alert color="green">Successfully updated</Alert>}
                <Button
                    color="green"
                    onClick={() => updateConfigApi(config)}
                    disabled={isLoading}
                    style={{width: "fit-content"}}
                >
                    {isLoading && <Loader size="sm" mr={6} />}
                    Update configuration
                </Button>
            </Stack>
      </Stack>
    )
}

const TagGroupTagsGrid = ({tagGroup, i1, updateConfig}) => {

    const { assetFrameworkServices } = useOutletContext()

    const deviceOptions = _.sortBy(assetFrameworkServices.getDevices(tagGroup.site_id).map(x => Object({label: x.full_path, value: String(x._id)})), "label")
    const tagOptions = _.sortBy(assetFrameworkServices.getTags().map(x => Object({label: x.name, value: String(x._id)})), "label")

    return (
        <Stack>
            <div style={{display: "grid", gap: 15, width: "fit-content"}}>
                <Text style={{gridRow: 1, gridColumn: 1}}>Device</Text>
                <Text style={{gridRow: 1, gridColumn: 2}}>Tag</Text>
                <Text style={{gridRow: 1, gridColumn: 3}}>Tag Res</Text>
                <Text style={{gridRow: 1, gridColumn: 4}}>Label</Text>
                <Text style={{gridRow: 1, gridColumn: 5}}>Units</Text>
                <Text style={{gridRow: 1, gridColumn: 6}}>Scaling</Text>
                {tagGroup.tags.map((tag, i2) => {
                    const scalingDecimalPart = tag._cust_config.scaling ? String(tag._cust_config.scaling).split(".")[1] : null
                    const scalingInputPrecision = scalingDecimalPart ? scalingDecimalPart.length : 0
                    return (
                        <>
                            <div style={{gridRow: i2+2, gridColumn: 1}}>
                                <Select
                                    data={deviceOptions}
                                    value={String(tag.device_id)}
                                    disabled
                                />
                            </div>
                            <div style={{gridRow: i2+2, gridColumn: 2}}>
                                <Select
                                    data={tagOptions}
                                    value={String(tag.tag_id)}
                                    disabled
                                />
                            </div>
                            <div style={{gridRow: i2+2, gridColumn: 3}}>
                                <Select
                                    data={[{label: "Interval", value: "interval"}, {label: "Raw", value: "raw"}]}
                                    value={tag.type}
                                    disabled
                                    style={{width: "100px"}}
                                />
                            </div>
                            <div style={{gridRow: i2+2, gridColumn: 4}}>
                                <TextInput
                                    value={tag._cust_config.label}
                                    onChange={(e) => {
                                        const value = e.currentTarget.value
                                        updateConfig((config_) => {
                                            console.log(config_.tag_groups[i1].tags[i2])
                                            config_.tag_groups[i1].tags[i2]._cust_config.label = value
                                        })
                                    }}
                                />
                            </div>
                            <div style={{gridRow: i2+2, gridColumn: 5}}>
                                <TextInput
                                    value={tag._cust_config.units}
                                    onChange={(e) => {
                                        const value = e.currentTarget.value
                                        updateConfig((config_) => {
                                            config_.tag_groups[i1].tags[i2]._cust_config.units = value
                                        })
                                    }}
                                    style={{width: "100px"}}
                                    />
                            </div>
                            <div style={{gridRow: i2+2, gridColumn: 6}}>
                                <NumberInput
                                    value={tag._cust_config.scaling}
                                    precision={scalingInputPrecision}
                                    onChange={(value) => {
                                        updateConfig((config_) => {
                                            config_.tag_groups[i1].tags[i2]._cust_config.scaling = value!==undefined ? value : null
                                        })
                                    }}
                                    hideControls
                                    style={{width: "100px"}}
                                />
                            </div>
                        </>
                    )
                })}
            </div>
            <Button
                color="red"
                onClick={() => {
                    updateConfig((config_) => {
                        config_.tag_groups.splice(i1, 1)
                    })
                }}
                sx={{width: "fit-content"}}
            >
                <Group spacing="xs">
                    <FontAwesomeIcon icon={faMinusCircle} />
                    Remove tag group
                </Group>
            </Button>
        </Stack>
    )
}

const AddTagGroupSection = ({updateConfig, configTagGroups}) => {

    const { assetFrameworkServices } = useOutletContext()

    const [selectedSiteId, setSelectedSiteId] = useState()
    const [selectedTagGroupId, setSelectedTagGroupId] = useState()
    const [showDupeAlert, setShowDupeAlert] = useState(false)

    return (
        <Stack>
            {showDupeAlert && <Alert color="red">Selected tag group already exists in configuration.</Alert>}
            <Group align="flex-end">
                <Select
                    label="Project"
                    data={assetFrameworkServices.getSites().map(x => Object({label: x.name, value: String(x._id)}))}
                    value={String(selectedSiteId)}
                    onChange={(x) => {
                        setSelectedSiteId(Number(x))
                        setSelectedTagGroupId(null)
                        setShowDupeAlert(false)
                    }}
                    searchable
                />
                <Select
                    label="Tag Group"
                    data={selectedSiteId ? assetFrameworkServices.getTagGroups(selectedSiteId).map(x => Object({label: x.name, value: String(x._id)})) : []}
                    value={String(selectedTagGroupId)}
                    onChange={(v) => {
                        setSelectedTagGroupId(Number(v))
                        setShowDupeAlert(false)
                    }}
                    nothingFound={selectedSiteId ? "No tag groups" : "Select a project first"}
                    clearable
                />
                <Button
                    color="green"
                    disabled={!Boolean(selectedTagGroupId)}
                    onClick={() => {
                        if (configTagGroups.find(x => x._id===selectedTagGroupId)) {
                            setShowDupeAlert(true)
                            return
                        }
                        updateConfig((config_) => {
                            const tagGroupSchema = buildDashboardTagGroupSchema(assetFrameworkServices.getTagGroup(selectedTagGroupId))
                            config_.tag_groups ? config_.tag_groups.push(tagGroupSchema) : config_.tag_groups = [tagGroupSchema]
                        })
                        setSelectedSiteId(null)
                        setSelectedTagGroupId(null)
                    }}
                >
                    <Group spacing="xs">
                        <FontAwesomeIcon icon={faPlusCircle} />
                        Add tag group
                    </Group>
                </Button>
            </Group>
        </Stack>
    )
}

const buildDashboardTagGroupSchema = (tagGroupSchema) => {
    const schema = _.cloneDeep(tagGroupSchema)
    for (const tagConfig of schema.tags) {
        tagConfig._cust_config = {
            label: null,
            scaling: null,
            units: null
        }
    }
    return schema
}